module.exports = __webpack_public_path__ + "static/index/img/baikal-810.1f4af6f9.jpg";